module.exports = __webpack_public_path__ + "static/img/D100_bg.460ea39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/D100_bg.jpg
// module id = tw/7
// module chunks = 0